let BASE_URL =  "https://api.pichainlabs.com";
let FRONTEND_URL = "http://localhost:3000";
let BULK_API_KEY = "7CZXhw2jsu4NZjiuUCgeCYiZGQiCYbmi";

// if (process.env.REACT_APP_ENV === "development") {
//   BASE_URL = "https://apidev.pichainlabs.com";
//   BULK_API_KEY = "7CZXhw2jsu4NZjiuUCgeCYiZGQiCYbmi";
// }

// if (process.env.REACT_APP_ENV === "production") {
//   BASE_URL = "https://api.pichainlabs.com";
//   BULK_API_KEY = "7CZXhw2jsu4NZjiuUCgeCYiZGQiCYbmi";
// }

export { BASE_URL, FRONTEND_URL, BULK_API_KEY };
